import styled from 'styled-components';

export const AutoLoginWrapper = styled.div`
  height: 100vh;
`;
